import TabBar from '@mobile/components/TabBar.vue';

export default {
    functional: true,
    render(h, { parent }) {
        return h(TabBar, {
            class: '',
            props: {
                tabs: [
                    {
                        title: parent.$t('Open'),
                        route: { name: 'issues' },
                    },
                    {
                        title: parent.$t('Solved'),
                        route: { name: 'issues-solved' },
                    },
                ],
            },
        });
    },
};
